module.exports = __webpack_public_path__ + "img/sharp2-1.55570042.png";